<template>
  <div class="media-container">
    <h1 class="heading-feature text-center mt-2">
      雑誌やメディアでも話題沸騰
    </h1>
    <div class="row media-magazine">
      <div class="col-md-5 text-center col-md-offset-1">
        <img src="/static/media/anan.jpg" alt="ananに掲載されました">
      </div>
      <div class="col-md-5 text-center">
        <img src="/static/media/hiyoko.jpg" alt="たまごクラブに掲載されました">
      </div>
    </div>
    <div class="media-slider">
      <slick ref="slick" :options="slickOptions">
        <img src="/static/media/01.png" alt="掲載メディア">
        <img src="/static/media/02.png" alt="掲載メディア">
        <img src="/static/media/03.png" alt="掲載メディア">
        <img src="/static/media/04.png" alt="掲載メディア">
        <img src="/static/media/05.gif" alt="掲載メディア">
        <img src="/static/media/06.png" alt="掲載メディア">
        <img src="/static/media/07.gif" alt="掲載メディア">
        <img src="/static/media/08.png" alt="掲載メディア">
        <img src="/static/media/09.png" alt="掲載メディア">
        <img src="/static/media/10.png" alt="掲載メディア">
        <img src="/static/media/11.png" alt="掲載メディア">
        <img src="/static/media/12.png" alt="掲載メディア">
        <img src="/static/media/13.png" alt="掲載メディア">
        <img src="/static/media/14.gif" alt="掲載メディア">
        <img src="/static/media/15.png" alt="掲載メディア">
        <img src="/static/media/16.png" alt="掲載メディア">
        <img src="/static/media/17.png" alt="掲載メディア">
        <img src="/static/media/18.png" alt="掲載メディア">
        <img src="/static/media/19.gif" alt="掲載メディア">
        <img src="/static/media/20.gif" alt="掲載メディア">
        <img src="/static/media/21.png" alt="掲載メディア">
        <img src="/static/media/22.png" alt="掲載メディア">
        <img src="/static/media/23.gif" alt="掲載メディア">
        <img src="/static/media/24.gif" alt="掲載メディア">
      </slick>
    </div>
    <p class="media-caption text-center mt-2">
      <span class="underline1">50以上のメディアに取り上げられています</span>
    </p>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Home',
  data() {
    return {
      movieNum: 160,
      slickOptions: {
        slidesToShow: 5,
        slidesToScroll: 2,
        swipe: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  // mounted () {
  //   axios
  //     .get('https://firebasestorage.googleapis.com/v0/b/legame-e45b7.appspot.com/o/web%2Fmovie.json?alt=media&token=ae1080b2-ff35-42e5-bd79-38b4592c5d51')
  //     .then(response => (this.movieNum = response.data['count']))
  // },
  components: {
    Slick
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.media-container {
  padding: 15px 0 40px;
  margin-top: 20px;
  border-top: 15px #eee solid;
  border-bottom: 15px #eee solid;
}

.media-container h1 {
  padding-bottom: 40px;
}

.media-caption {
  font-size: 18px;
  padding: 0 20px;
}

.media-magazine img {
  padding: 10px 15px;
  max-height: 480px;
  max-width: 100%;
}

.media-slider {
  padding: 80px 0 0;
}

.media-slider img {
  padding: 0 50px;
  object-fit: cover;
  line-height: 100%;
}

@media screen and (max-width: 640px) {
  .media-container {
    padding: 20px 0;
  }

  .media-container h1 {
    font-size: 24px;
    padding-bottom: 20px;
  }

  .media-slider {
    padding: 20px 0 0;
  }

  .media-slider img {
    padding: 0 30px;
  }
}

.heading-feature {
  margin-top: 40px;
  font-weight: bold;
  font-size: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/Media.vue